@import '../../../constants/spacing.module.less';

.msds-upload {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-8;
}

.upload-section {
  display: flex;
  align-items: center;
  gap: @space-12;
}

.file-info {
  display: flex;
  align-items: center;
  gap: @space-12;
}

.file-name-button {
  font-size: 12px;
  line-height: 16px;
}

.upload-date {
  color: var(--grey-600);
}

.remove-button {
  display: flex;
  align-items: center;
  gap: @space-4;
  color: var(--red-700);
  font-size: 12px;
  line-height: 16px;
}

.remove-button-icon {
  height: 16px;
  width: 16px;
  padding: 2px; // figma icon padding
}

.loading-indicator {
  width: 32px;
  height: 32px;
}

.error-message {
  color: var(--error--message--text-color--1);
}
